import React, { Component } from 'react';

class FormGroup extends Component {

  state = {
    select: false
  }
  
  render() {

    const props = this.props,
      css = [ 'form-group' ];

    if( props.class ) css.push(props.class);
    if( props.type === 'select' ) css.push("form__select__group")
    if( props.error ) css.push('form-group_error');

    const settingsParent = {
        className: css.join(' ')
      },
      settings = {
        className: "form__input",
        type: props.type ? props.type : 'text',
        name: props.name,
        onChange: e => props.handleChange(e),
        required: props.required,
        value: props.value,
        placeholder: props.placeholder
      };

    return (
      <div {...settingsParent}>

        { props.type !== 'select' ? <input {...settings}/> : '' }
        
        { props.type === 'select' ?
          <div className={'form__select'+( this.state.select ? ' form__select--active' : '' )} onMouseOver={ () => this.setState({ select: true }) } onMouseOut={ () => this.setState({ select: false }) }>
            <i className="ico_arrow"></i>
            <label className={ props.value ? 'active' : '' }>{ props.value ? props.value : props.placeholder }</label>
            <ul style={{
                paddingTop: this.state.select ? '20px' : '0px',
                paddingBottom: this.state.select ? '10px' : '0px',
                height: this.state.select ? ( ((props.values.length+1) * 18) + 30 )+'px' : '0px'
              }}>
              <li className="default" onClick={ () => settings.onChange({ name: props.name, value: 0 }) }>все</li>
              { props.values && props.values.map( (v,i) => {

                var vt = v.title ? v.title : v,
                  vv = v.value ? v.value : v;

                return <li key={i} onClick={ () => settings.onChange({ name: props.name, value: v.title ? { title: vt, value: vv } : vv }) }>{vt}</li>;
              })}
            </ul>
          </div>
          : '' }

        { props.error ? <div className="form-group__error">{props.error}</div> : '' }
      </div>
    );
  }
}
export default FormGroup;